"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _axios = _interopRequireDefault(require("axios"));
var _constants = require("../constants");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
class AddressService {
  constructor() {
    this.client = _axios.default.create();
  }
  getAddresses = () => this.client.get(`${_constants.ADDRESS_API_BASE_URL}/`);
  getAddress = id => this.client.get(`${_constants.ADDRESS_API_BASE_URL}/${id}`);
  createAddress = data => this.client.post(`${_constants.ADDRESS_API_BASE_URL}/`, data);
  updateAddress = data => this.client.put(`${_constants.ADDRESS_API_BASE_URL}/`, data);
  deleteAddress = id => this.client.delete(`${_constants.ADDRESS_API_BASE_URL}/${id}`);
  getFavouriteAddress = () => this.client.get(`${_constants.ADDRESS_API_BASE_URL}/favourite`);
  getAddressSpecificities = () => this.client.get(`${_constants.CONFIG_API_BASE_URL}/features/target/postsales/web/address-specificities`);
}
exports.default = AddressService;